const NotFound = () => (
  <div className='NotFound'>
    <h1>404</h1>
    <span>NOT FOUND</span>
  </div>
)

export default NotFound
